import { render, staticRenderFns } from "./bannerIcon.vue?vue&type=template&id=27e0bc5e&"
import script from "./bannerIcon.vue?vue&type=script&lang=js&"
export * from "./bannerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports